import styled from "@emotion/styled";
import TextFieldComponent from "@components/form/TextField";
import CheckboxComponent from "@components/form/Checkbox";
import LabelComponent from "@components/form/Label";
import { theme } from "@styles/theme";
const { sm, md, lg, xl } = theme.breakpoints;
export const Container = styled.div`
  @media (max-width: ${xl}) {
    font-size: 11px;
  }
  @media (max-width: ${lg}) {
    font-size: 14px;
  }
`;
export const ContainerSwitch = styled.div`
  display: flex;
  margin-bottom: 2em;
  align-items: center;
`;
export const LabelSwitch = styled.div`
  font-family: Poppins Ligth;
  font-size: 1em;
  margin-right: 0.8em;
`;
export const Relationship = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 90%;
  align-items: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 1em;
  margin-bottom: 2em;
  @media (max-width: ${lg}) {
    width: 100%;
  }
`;
export const LabelRelationship = styled.div`
  color: #6d6d6d;
  font-family: Poppins Ligth;
  font-size: 1em;
  @media (max-width: ${md}) {
    margin-bottom: 1.5em;
  }
`;
export const Checkbox = styled(CheckboxComponent)`
  font-size: 1em;
  margin-bottom: 0;
  @media (max-width: ${md}) {
    margin-bottom: 1.5em;
  }
  /*  @media (max-width: ${md}) {
    :last-of-type {
      margin-top: 1.5em;
    }
  }
  @media (max-width: ${sm}) {
    margin-bottom: 1.5em;
    :last-of-type {
      margin-top: 0;
    }
  } */
`;
export const DataPersonal = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  background-color: #f2f2f6;
  border: #707070 solid 1px;
  padding: 2em 3em;
  padding-bottom: 1em;
  justify-content: space-between;
  box-sizing: border-box;
  border-radius: 1em;
  /* margin: 2em 0; */
  margin-bottom: 2em;
  @media (max-width: ${md}) {
    padding: 1em;
    padding-bottom: 0;
  }
`;
export const TextField = styled(TextFieldComponent)`
  margin: 0.5em 1em;
  font-size: 0.9em;
  border-radius: 0.3em;
`;

export const Label = styled(LabelComponent)`
  position: relative;
  color: #6d6d6d;
  display: flex;
  flex-direction: column;
  font-family: "Poppins Regular";
  width: 26%;
  margin-bottom: 1.5em;
  @media (max-width: ${md}) {
    width: 45%;
  }
  @media (max-width: ${sm}) {
    width: 100%;
  }
  :last-of-type {
    width: 45%;
    @media (max-width: ${lg}) {
      width: 55%;
    }
    @media (max-width: ${md}) {
      width: 100%;
    }
  }
`;
export const TextFieldPersonal = styled(TextField)`
  font-size: 0.9em;
  margin: 0.5em 0;
  width: 100%;
`;
export const DocumentInput = styled(TextFieldPersonal)`
  margin: 0.5em 1em;
  margin-right: 0;
`;
export const GroupInput = styled.div`
  display: flex;
  width: 100%;
`;

export const Error = styled.div`
  position: absolute;
  top: 100%;
  font-family: Poppins Ligth;
  color: red;
`;
